import { z } from 'zod';

const RECAPTCHA_SITE_KEY = z
  .string()
  .parse(process.env.PUBLIC_RECAPTCHA_SITE_KEY);

const SCRIPT_SRC = 'https://www.google.com/recaptcha/enterprise.js?render=';

export async function loadRecaptcha(): Promise<typeof window.grecaptcha> {
  if (window.grecaptcha !== undefined) {
    return window.grecaptcha;
  }

  return new Promise((res) => {
    const script = document.createElement('script');
    script.setAttribute('data-testid', 'recaptcha-script');
    script.setAttribute('src', `${SCRIPT_SRC}${RECAPTCHA_SITE_KEY}`);

    script.addEventListener(
      'load',
      () => {
        res(window.grecaptcha);
      },
      {
        once: true,
      }
    );

    document.body.appendChild(script);
  });
}

export async function generateToken(
  action: Parameters<ReCaptchaV2.ReCaptcha['execute']>[1]
) {
  const sdk = await loadRecaptcha();
  await new Promise<void>((res) => {
    sdk.enterprise.ready(res);
  });

  return sdk.enterprise.execute(RECAPTCHA_SITE_KEY, action);
}
